import coreAPIInstance from "./coreApiInstance";

export const contentVariantAPIs = {
  bulkGenerateAudioVariant: ({ payload }) => coreAPIInstance.post("/api/v1/variants.audio.generate", payload),
  listContentVariants: ({ payload }) => coreAPIInstance.post("/api/v1/variants.list", payload),
  listClipListReferenceVariants: ({ payload }) =>
    coreAPIInstance.get(`/api/v1/clip-list/variants.reference/${payload.folderId}`, {
      headers: { entityid: payload?.entityId },
    }),
  createClipListReferenceVariant: ({ payload }) =>
    coreAPIInstance.post(`/api/v1/clip-list/variants.reference.create`, payload),
  deleteClipListReferenceVariant: ({ payload }) =>
    coreAPIInstance.post(`/api/v1/clip-list/variants.reference.delete`, payload),
  deleteContentVariant: ({ payload }) => coreAPIInstance.delete(`/api/v1/variant.delete/${payload.variantId}`, payload),
};
